import React, { useState } from "react";
import { Container } from "react-bootstrap";
import "../../styles/Work/WorkGallery.scss";
import { ImCross } from "react-icons/im";
import Img1 from "../../assets/images/random7.png";
import Img2 from "../../assets/images/random2.png";
import Img3 from "../../assets/images/random6.png";
import Img4 from "../../assets/images/random4.png";
import Img5 from "../../assets/images/random8.jpg";
import Img6 from "../../assets/images/random9.png";
import Img7 from "../../assets/images/random10.png";
import Img8 from "../../assets/images/random11.png";
import Img9 from "../../assets/images/random12.png";
import Img10 from "../../assets/images/random1.jpg";
import Img11 from "../../assets/images/random5.png";
import Img12 from "../../assets/images/random3.png";
import { Link } from "react-router-dom";
const WorkGallery = () => {
  let data = [
    {
      id: 1,
      imgSrc: Img1,
    },
    {
      id: 2,
      imgSrc: Img2,
    },
    {
      id: 4,
      imgSrc: Img4,
    },
    {
      id: 3,
      imgSrc: Img3,
    },
    {
      id: 5,
      imgSrc: Img5,
    },
    {
      id: 6,
      imgSrc: Img6,
    },
    {
      id: 7,
      imgSrc: Img7,
    },
    {
      id: 8,
      imgSrc: Img8,
    },

    {
      id: 9,
      imgSrc: Img9,
    },
    {
      id: 10,
      imgSrc: Img10,
    },
    {
      id: 11,
      imgSrc: Img11,
    },
    {
      id: 12,
      imgSrc: Img12,
    },
  ];
  const [open, setOpen] = useState(false);
  const [model, setModel] = useState(false);
  const [tempimgSrc, setTempImgSrc] = useState("");
  const getImg = (imgSrc) => {
    setTempImgSrc(imgSrc);
    setModel(true);
  };

  return (
    <Container>
      <div className={model ? "model open" : "model"}>
        <img src={tempimgSrc} alt="" />
        <ImCross onClick={() => setModel(false)} />
      </div>
      <div className="work-gallery-title title">Work</div>
      <nav>
        <ul>
          <li>
            <a href="#">All Categories</a>
          </li>
          <li>
            <a href="#">Brand</a>
          </li>
          <li>
            <a href="#">Brand</a>
          </li>
          <li>
            <a href="#">Brand</a>
          </li>
        </ul>
      </nav>
      {
        <div className="gallery ">
          {data.map((item, index) => {
            return (
              <Link to="/work-details" className="d-inline-block">
                <div
                  className="pics"
                  key={index}
                  onClick={() => getImg(item.imgSrc)}
                >
                  <img
                    src={item.imgSrc}
                    alt=""
                    style={{ width: "100%" }}
                    className="img-fluid"
                  />
                </div>
              </Link>
            );
          })}
        </div>
      }
    </Container>
  );
};

export default WorkGallery;
